module.exports = {
      id: "plus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }